import * as React from 'react'

import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'

import { cn } from '@lib/cn'

interface Props extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> {
  orientation?: 'vertical' | 'horizontal'
}

const ScrollArea = React.forwardRef<React.ElementRef<typeof ScrollAreaPrimitive.Root>, Props>(
  ({ className, children, id, orientation = 'vertical', ...props }, ref) => (
    <ScrollAreaPrimitive.Root ref={ref} className={cn('relative overflow-hidden', className)} {...props}>
      <ScrollAreaPrimitive.Viewport id={id} className="h-full w-full rounded-[inherit]">
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollAreaPrimitive.ScrollAreaScrollbar
        orientation={orientation}
        className={cn(
          'flex touch-none select-none transition-colors p-[1px]',
          orientation === 'vertical' && 'h-full w-2.5 border-s border-s-transparent',
          orientation === 'horizontal' && 'h-2.5 flex-col border-t border-t-transparent'
        )}
      >
        <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 bg-o-line-strong rounded-full" />
      </ScrollAreaPrimitive.ScrollAreaScrollbar>
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
)
ScrollArea.displayName = 'ScrollArea'

export { ScrollArea }
